import React, { useState } from "react";
import { submitContactUs } from "../utils/api";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [agree, setAgree] = useState(false);
  const [response, setResponse] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setResponse(null);

    try {
      await submitContactUs({
        Name: name.trim(),
        Email: email.trim(),
        Phone: phone.trim(),
        Message: message.trim(),
        SubscriptionId: "PublicWeb",
        Location: "Website",
        Department: "General Inquiry",
        ReferralCode: "",
        SourceBy: "Web Contact Form",
      });
      setResponse({ type: "success", text: "Thank you! Your message has been sent successfully." });
      setName(""); setEmail(""); setPhone(""); setMessage(""); setAgree(false);
    } catch (err) {
      setResponse({ type: "error", text: "Unable to send message. Please try again later." });
    }
    setSubmitting(false);
  };

  return (
    <div className="page-contact">
      <section className="contact-hero">
        <div className="container">
          <div className="hero-badge" style={{ marginBottom: 16 }}>Support &middot; Help &middot; Guidance</div>
          <h1>Get in Touch</h1>
          <p>
            If you have any questions regarding the informed consent process, your rights as a participant,
            data privacy, or how your samples will be used in research, our Biobank Support Team is here to assist you.
          </p>
        </div>
      </section>

      <section className="contact-info-section">
        <div className="container">
          <div className="contact-info-cards">
            <a href="mailto:info@resonancebiobank.com" className="contact-info-card">
              <div className="contact-info-icon">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.83174 11.7413V14.8333C5.83225 14.9384 5.86581 15.0407 5.92767 15.1256C5.98953 15.2106 6.07655 15.2739 6.1764 15.3066C6.27625 15.3394 6.38388 15.3399 6.48403 15.3081C6.58418 15.2762 6.67177 15.2137 6.73441 15.1293L8.54308 12.668L5.83174 11.7413ZM15.7884 0.0926552C15.7133 0.0391576 15.6248 0.00748045 15.5328 0.001127C15.4408 -0.00522644 15.3488 0.0139914 15.2671 0.0566552L0.267077 7.88999C0.180772 7.9356 0.109661 8.00542 0.0624712 8.09087C0.0152814 8.17633 -0.00593423 8.2737 0.00142817 8.37104C0.00879056 8.46838 0.0444106 8.56145 0.103917 8.63883C0.163423 8.71622 0.244227 8.77454 0.336411 8.80666L4.50641 10.232L13.3871 2.63866L6.51508 10.918L13.5037 13.3067C13.5731 13.33 13.6467 13.3378 13.7194 13.3297C13.7921 13.3216 13.8622 13.2976 13.9246 13.2596C13.9871 13.2216 14.0405 13.1703 14.0812 13.1095C14.1218 13.0486 14.1486 12.9796 14.1597 12.9073L15.9931 0.573989C16.0066 0.482688 15.9947 0.389414 15.9586 0.304471C15.9225 0.219528 15.8636 0.146223 15.7884 0.0926552Z" fill="currentColor" />
                </svg>
              </div>
              <span>info@resonancebiobank.com</span>
            </a>
            <a href="tel:+914069286747" className="contact-info-card">
              <div className="contact-info-icon">
                <svg width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M15.5633 11.7424L13.3305 9.50954C12.5331 8.71209 11.1774 9.0311 10.8584 10.0678C10.6192 10.7855 9.82174 11.1842 9.10404 11.0247C7.50915 10.626 5.35604 8.5526 4.95732 6.87797C4.71809 6.16024 5.19656 5.36279 5.91426 5.12359C6.95094 4.80461 7.26991 3.44895 6.47247 2.65151L4.23962 0.418659C3.60166 -0.139553 2.64473 -0.139553 2.08652 0.418659L0.57137 1.93381C-0.943776 3.5287 0.73086 7.75516 4.47885 11.5032C8.22685 15.2511 12.4533 17.0056 14.0482 15.4106L15.5633 13.8955C16.1216 13.2575 16.1216 12.3006 15.5633 11.7424Z" fill="currentColor" />
                </svg>
              </div>
              <span>+91 40 69286747</span>
            </a>
          </div>
        </div>
      </section>

      <section className="contact-form-section">
        <div className="container">
          <div className="contact-form-wrap">
            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="form-grid cols-3">
                <div className="form-group">
                  <label>Full Name*</label>
                  <input value={name} onChange={(e) => setName(e.target.value)} maxLength={100} required placeholder="Enter full name" />
                </div>
                <div className="form-group">
                  <label>Email Address*</label>
                  <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" maxLength={50} required placeholder="Enter email address" />
                </div>
                <div className="form-group">
                  <label>Phone*</label>
                  <input value={phone} onChange={(e) => setPhone(e.target.value)} maxLength={12} required placeholder="Enter phone number" />
                </div>
              </div>
              <div className="form-group">
                <label>Your Query</label>
                <textarea value={message} onChange={(e) => setMessage(e.target.value)} maxLength={2000} required placeholder="Type your message" rows={5}></textarea>
              </div>
              <div className="consent-checkbox-row">
                <input type="checkbox" id="contactAgree" checked={agree} onChange={(e) => setAgree(e.target.checked)} required />
                <label htmlFor="contactAgree">I agree to receive follow-up emails about my request and related services.</label>
              </div>
              <button type="submit" className="btn-primary-action" disabled={submitting}>
                {submitting ? "Submitting..." : "Submit Inquiry"}
                {!submitting && (
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" style={{marginLeft: 8}}>
                    <path fillRule="evenodd" clipRule="evenodd" d="M2.41379 3.30208C5.97452 3.05821 10.6092 1.55558 14 0C12.4438 3.39014 10.9406 8.02425 10.6973 11.585L8.35765 6.59331L1.14783 13.8037C1.02165 13.9295 0.850656 14.0001 0.672431 14C0.539461 14 0.409486 13.9605 0.298934 13.8866C0.188382 13.8128 0.102217 13.7077 0.0513353 13.5849C0.000453949 13.462 -0.0128613 13.3269 0.013072 13.1965C0.0390053 13.066 0.103024 12.9462 0.197034 12.8522L7.40683 5.64241L2.41379 3.30208Z" fill="currentColor" />
                  </svg>
                )}
              </button>
              {response && (
                <p className={`form-response ${response.type === "success" ? "text-success" : "text-error"}`}>{response.text}</p>
              )}
            </form>
          </div>
        </div>
      </section>

      <section className="contact-map">
        <iframe
          title="Map"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1510540.0480819119!2d42.0385954955818!3d42.31536428549862!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40440cd7e64f626b%3A0x4f907964122d4ac2!2sGeorgia!5e0!3m2!1sen!2sbd!4v1714619203308!5m2!1sen!2sbd"
          style={{ border: 0, width: "100%", height: "400px" }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </section>
    </div>
  );
}
